import React from 'react';
import { Link } from 'react-router-dom';
import SubscriptionManager from '../components/SubscriptionManager';

const SubscriptionPage = ({ user, onSubscriptionUpdate }) => {
  if (!user || user.id === -1) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Login Required</h2>
          <p className="text-gray-600 mb-6">You need to be logged in to manage your subscription.</p>
          <Link to="/login" className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700">
            Go to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <h1 className="text-2xl font-bold text-gray-900">Subscription Management</h1>
            <div className="flex items-center space-x-4">
              <Link
                to="/dashboard"
                className="text-gray-600 hover:text-gray-900"
              >
                ← Back to Dashboard
              </Link>
              <span className="text-sm text-gray-600">{user.username.split('@')[0].charAt(0).toUpperCase() + user.username.split('@')[0].slice(1)}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <SubscriptionManager user={user} onSubscriptionUpdate={onSubscriptionUpdate} />
      </div>
    </div>
  );
};

export default SubscriptionPage;